'use strict';

import Component from 'generic.basecomponent';

export default class ContentHeading extends Component {
    constructor(el) {
        super(el);
        this.init();
        this.maxNestedLevelsCount = 5;
    }

    init() {
        let parentModule = null;
        let parent = this.container;
        let levelCount = 0;
        while (parent.parentElement !== null) {
            parent = parent.parentElement;

            if (parent.classList.contains('module') && parent.parentElement && parent.parentElement.classList.contains('module--content')) {
                parentModule = parent;
                break;
            }

            levelCount++;
            if (levelCount > this.maxNestedLevelsCount) {
                break;
            }
        }

        if (parentModule) {
            parentModule.classList.add('module--content-heading');
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/content-heading/js/generic.content-heading.js